import React from 'react';
import './styles.scss';

const Button = ({
  children,
  theme,
  ...rest
}) => (
  <button
    className={`Button Button__${theme}`}
    {...rest}
  >
    {children}
  </button>
);

Button.defaultProps = {
  theme: 'info',
};

export default Button;